import { defaults, each } from 'lodash-es';

import { services } from 'services/base';
import { NameSpace, User } from 'types';
import { getMainConfig, registerStateServices } from 'utils';

const SERVICE_PREFIX = 'appFrame.userStorage';
const DEFAULT_CONFIG = {
  updateInterval: 60 * 1000,
};

const initUserStorageServices = async () => {
  const { registerService } = services;

  const config = getMainConfig('userStorage');

  const createStorageByUser = async (user: User | null) => {
    const namespace: NameSpace = {
      appInstance: 'AppFrame',
      appPart: 'UserStorage',
      name: 'UserId',
      userId: (user?.profile?.preferred_username || user?.profile?.sub) ?? '{GUEST}',
    };
    const storageKey = services.appFrame.storage.convertNameSpaceToKey(namespace);
    const userStorageConfig = defaults({ storageKey }, config, DEFAULT_CONFIG);
    return await services.appFrame.storage.createStorageWithNameSpace(userStorageConfig);
  };

  const storage = await createStorageByUser(services.appFrame.auth.getUser());
  const state = { storage };

  const { setter: setUserStorage, getter: getUserStorage } = registerStateServices({
    state,
    servicePrefix: SERVICE_PREFIX,
    stateKey: 'storage',
    initValue: storage,
    serviceMethods: {
      onChange: 'onUserStorageChange',
    },
  });

  // map the service methods into `AppFrame.userStorage` and always call the methods from the current storage instance
  each(getUserStorage(), (_value, key) => {
    registerService(`${SERVICE_PREFIX}.${key}`, (...args: unknown[]) => state.storage[key](...args));
  });

  services.appFrame.auth.onUserChange((user) => {
    createStorageByUser(user).then((newStorage) => setUserStorage(newStorage));
  });
};

export default initUserStorageServices;
